import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AddEntityPage } from './add-entity';

const routes: Routes = [
  {
    path: '',
    component: AddEntityPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AddEntityPageRoutingModule { }
